// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__29Y0v","cell":"ColumnAccessor_cell__1Mi3Y","firstCellAccent":"ColumnAccessor_firstCellAccent__1bdct"};